import React from 'react'

import {ButtonHeader} from '../../component/Button/ButtonHeader'
import TransactionService from '../../transaction/TransactionService'
import {
  dayMonthYear,
  dayMonthYearAtTime,
  dayMonthYearAtTimeWithSeconds
} from '../../utils/dates'
import Notify from '../../services/Notify'
import EPCLink from "../../component/Asset/EPCLink";
import TransactionItemWrongWorkflow from '../../transaction/component/TransactionItemWrongWorkflow'

const transactionService = new TransactionService()

export const deleteEpc = async (itemId, epc) => {
  try {
    await transactionService.deleteEpcByItemId(itemId, epc)
    return Notify.success('Item deletado com sucesso')
  } catch (error) {
    return Notify.error('Houve um erro ao deletar o item')
  }
}

class PortalTransactionsEpcGrid {

  constructor() {
    this.deleteEpc = deleteEpc
  }

  getColumns = (props, state, setState) => {

    return  [
      {
        Header: 'EPC',
        Cell: row => <EPCLink epc={row.original.epc}/>
      },
      {
        Header: 'Serial',
        Cell: row => row.original.serial || ''
      },
      {
        Header: 'Lote',
        Cell: row => (row.original.asset && row.original.asset.lot)
            ? row.original.asset.lot.code : ''
      },
      {
        Header: 'Data/Hora da Leitura',
        Cell: row => row.original.readDate ? dayMonthYearAtTime(row.original.readDate) : ''
      },
      {
        Header: 'Status do Fluxo',
        style: { whiteSpace: 'unset' },
        Cell: row => <TransactionItemWrongWorkflow wrongWorkflowData={row.original && row.original.wrongWorkFlow}/>
      },
      {
        Header: 'Excluir',
        Cell: row => (
            <div style={styles.buttonContainer}>
              <ButtonHeader
                  onClick={() => {
                    this.deleteEpc(row.original.id, row.original.epc.value, row)
                    setState({endpoint: state.metadata.endpoint})
                  }}
                  icon="trash fa-lg"
                  iconStyle={{color: '#ff6961'}}
                  style={{border: 'none', outline: 'none', background: 'none'}}
              />
            </div>
        )
      },
    ];
  }
  
  endpoint = `ton/v1/transactions/items`;
}


const styles = {
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
}

export default PortalTransactionsEpcGrid;



// WEBPACK FOOTER //
// ./src/customGrid/entities/PortalTransactionsEpcGrid.js